<div class="search-panel-container">
  <div class="panel-header">
    <h2 class="panel-title">{{ panelTitle }}</h2>
  </div>

  <form [formGroup]="searchForm" class="panel-content" (keydown.enter)="onSearch()">
    <div class="form-field search-by-field" *ngIf="!(isNameSearch && currentStep === 2)">
      <lib-cdw-select
        formControlName="searchBy"
        [values]="searchByOptions"
        [label]="searchByLabel"
        placeholder="Select search method"
      ></lib-cdw-select>
    </div>

    <!-- Step 1: Name search inputs -->
    <div class="form-field name-search" *ngIf="isNameSearch && currentStep === 1">
      <p class="name-search-hint">At least one name field must be filled to proceed.</p>
      <mat-form-field class="name-field">
        <mat-label>Given name</mat-label>
        <input matInput formControlName="givenName" placeholder="Starts with...">
        <mat-error *ngIf="searchForm.get('givenName')?.hasError('noSpaces')">Spaces are not allowed</mat-error>
      </mat-form-field>
      <mat-form-field class="name-field">
        <mat-label>Family name</mat-label>
        <input matInput formControlName="familyName" placeholder="Starts with...">
        <mat-error *ngIf="searchForm.get('familyName')?.hasError('noSpaces')">Spaces are not allowed</mat-error>
      </mat-form-field>
      <div *ngIf="searchError" class="error-message">{{ searchError }}</div>
    </div>

    <!-- Step 2: Name search results -->
    <div class="name-results" *ngIf="isNameSearch && currentStep === 2">
      <div *ngIf="nameSearchResults.length === 0" class="no-results">
        No users found matching your search.
      </div>
      <button
        *ngFor="let result of nameSearchResults; trackBy: trackByNameResult"
        type="button"
        class="result-item"
        (click)="onSelectResult(result)"
      >
        <lib-cdw-user-option [name]="result.name" [email]="result.email"></lib-cdw-user-option>
      </button>
      <div *ngIf="resultsAtLimit" class="results-info">
        Results are limited to 50
      </div>
    </div>

    <!-- Email / Device search input -->
    <div class="form-field search-value-field" *ngIf="!isNameSearch">
      <lib-common-ui-components-text-input
        formControlName="searchValue"
        [label]="inputLabel"
        [placeholder]="inputPlaceholder"
        [required]="true"
        [hideRequiredMarker]="true"
      ></lib-common-ui-components-text-input>
      <div *ngIf="showValidationError" class="error-message">
        {{ validationErrorMessage }}
      </div>
      <div *ngIf="searchError" class="error-message">
        {{ searchError }}
      </div>
    </div>

    <div class="panel-actions flex flex-row mt-auto">
      <lib-cdw-button
        *ngIf="isNameSearch && currentStep === 2"
        (buttonClick)="onBack()"
        level="secondary"
        fontFamily="Roboto, sans-serif"
        [fontColor]="gray400"
        fontWeight="700"
      >
        Back
      </lib-cdw-button>
      <lib-cdw-button
        (buttonClick)="onCancel()"
        level="secondary"
        fontFamily="Roboto, sans-serif"
        [fontColor]="gray400"
        fontWeight="700"
      >
        Cancel
      </lib-cdw-button>
      <lib-cdw-button
        *ngIf="!(isNameSearch && currentStep === 2)"
        (buttonClick)="onSearch()"
        level="primary"
        fontFamily="Roboto, sans-serif"
        [fontColor]="gray400"
        fontWeight="700"
        [disabled]="isSearchDisabled"
      >
        <div class="flex items-center gap-2">
          <lib-cdw-spinner *ngIf="isSearching" type="apple" size="small" color="white"></lib-cdw-spinner>
          <span>Search</span>
        </div>
      </lib-cdw-button>
    </div>
  </form>
</div>
